import { ChangeDetectionStrategy, Component, effect, input, viewChild } from '@angular/core'
import { ShopBankOfferDto } from '@mos/api/bank/dto-client'
import { CanvasEmitterComponent } from '@mos/client/shared/canvas/components/canvas-emitter.component'
import { EmitterConfig } from '@mos/client/shared/canvas/models/emitter.config'
import { ParticleStarDiffracted, ParticleStarGlowing } from '@mos/client/shared/canvas/models/presets'
import { LeaveSyncDirective } from '@mos/client/shared/utils'
import { HeaderComponent } from '@mos/client/web/core/components/header/header.component'
import { AbstractModalComponent } from '@mos/client/web/core/components/modal/abstract-modal.component'
import { ModalComponent } from '@mos/client/web/core/components/modal/modal.component'
import { OfferComponent } from '@mos/client/web/shop/feature/components/offer/offer.component'
import { randomInRange } from '@mos/shared/utils'

@Component({
	selector: 'mos-christmas-promo-modal',
	imports: [ModalComponent, HeaderComponent, OfferComponent, CanvasEmitterComponent, LeaveSyncDirective],
	templateUrl: './christmas-promo.modal.html',
	styleUrl: './christmas-promo.modal.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChristmasPromoModal extends AbstractModalComponent {
	public static modalId = 'christmas-promo'

	private emitterConfig: EmitterConfig = {
		displayArea: { width: 336, height: 336 },
		spawnRate: 2,
		spawnArea: () => ({ x: 33, y: 33, width: 268, height: 268 }),
		velocityX: () => randomInRange(-0.005, 0.005),
		velocityY: () => randomInRange(-0.005, 0.005),
		velocityAlpha: (particle) => 1 / particle.ttl,
		initialScaleX: () => randomInRange(0.7, 1.3),
		initialScaleY: (particle) => particle.scaleX,
		ttl: () => randomInRange(2000, 3000),
		tint: () => '#ffffff',
	}
	protected emitter1Config: EmitterConfig = {
		...this.emitterConfig,
		...ParticleStarGlowing,
		tint: () => '#FFFFFFFF',
	}
	protected emitter2Config: EmitterConfig = {
		...this.emitterConfig,
		...ParticleStarDiffracted,
		spawnRate: 1,
	}

	readonly emitter1 = viewChild<CanvasEmitterComponent>('emitter1')
	readonly emitter2 = viewChild<CanvasEmitterComponent>('emitter2')

	offers = input<ShopBankOfferDto[]>()

	leave() {
		this.modal()?.close()
	}

	burstOnDisplay = effect(() => {
		if (this.modal()?.shouldDisplayContent()) {
			setTimeout(() => {
				const emitter1 = this.emitter1()
				const emitter2 = this.emitter2()
				if (emitter1 && emitter2) {
					emitter1.burst(3, this.emitter1Config)
					emitter2.burst(1, this.emitter2Config)
				}
			})
		}
	})
}
